<template>
    <div class="hypothec-calculator">
        <!-- {{price}} -->
        <!-- {{initPrice}} -->
        <!-- Сделать функцию автоматической подмены максимального значения в полях -> input keyup -->
        <div class="column-container">
            <div class="col-left">
                <div class="calculator-title">
                    <strong>{{ calculatorPage.syntax.calc_title_home }}</strong>
                </div>
                <div class="calculator-items">
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.syntax.filter_price}}</label>
                            <!-- <input type="number" name="price"  class="form-control" v-model="price" @keyup="keymonitor"> -->
                            <!-- @value="toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')" -->
                            <input type="number" name="price"  class="form-control" v-model="price"  @keyup="keymonitor">
                            <svgIcon name="tenge" class="icon-tenge"/>
                        </div>
                        <div class="calculator-slider">
                            <vue-slider v-model="price" :min="minPrice" :max="maxPrice" :interval="interval" @change="countPriceInitPercent()"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.syntax.filter_initprice}} {{pricePercent + '%'}}</label>
                            <input type="number" name="initPrice" class="form-control" v-model="initPrice" @keyup="keymonitor">
                            <svgIcon name="tenge" class="icon-tenge"/>
                        </div>
                        <div class="calculator-slider">
                            <vue-slider v-model="initPrice" :min="minInitPrice" :max="maxInitPrice" :interval="interval" @change="countPriceInitPercent()"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.syntax.filter_rate}}</label>
                            <input type="number" name="initPrice" class="form-control" v-model="curRate" @keyup="keymonitor">
                            <svgIcon name="precent" class="icon-precent"/>
                        </div>
                        <div class="calculator-slider">
                            <vue-slider v-model="curRate" :min="1" :max="maxCurRate" :interval="1"/>
                        </div>
                    </div>
                    <div class="calculator-item">
                        <div class="calculator-input">
                            <label>{{calculatorPage.syntax.filter_year}}</label>
                            <input type="number" name="initPrice" class="form-control" v-model="creditYear" @keyup="keymonitor">
                            <svgIcon name="calendar" class="icon-calendar"/>
                        </div>
                        <div class="calculator-slider">
                            <vue-slider v-model="creditYear" :min="1" :max="maxCreditYear" :interval="1"/>
                        </div>
                    </div>
                </div>
                <div class="count-total-amount">
                    <a href="#" class="default-red-link" @click.prevent="totalAmountPrice">{{calculatorPage.syntax.btn_result}}</a>
                    <span class="error-msg" v-if="errorMsg">Заполните все поля</span>
                </div>
            </div>
            <div class="col-right">
                <div class="calculator-total-desc">
                    <div class="calculator-total-title">
                        <strong>{{ calculatorPage.syntax.result_title }}</strong>
                    </div>
                    <div class="total-items-container">
                        <div class="total-item">
                            <div class="label">
                                <h3>{{calculatorPage.syntax.result_month_pay}}</h3>
                            </div>
                            <div class="total-amount">
                                <p>{{payPerMonth}} </p>
                                <svgIcon name="tenge" class="icon-tenge"/>
                            </div>
                        </div>
                        <div class="total-item">
                            <div class="label">
                                <h3>{{calculatorPage.syntax.result_total_price}}</h3>
                            </div>
                            <div class="total-amount">
                                <p>{{totalFlatPrice}}</p>
                                <svgIcon name="tenge" class="icon-tenge"/>
                            </div>
                        </div>
                        <div class="total-item">
                            <div class="label">
                                <h3>{{calculatorPage.syntax.result_over_price}}</h3>
                            </div>
                            <div class="total-amount">
                                <p>{{ovetBankAmount}}</p>
                                <svgIcon name="tenge" class="icon-tenge"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="calculator-total-links">
                    <div class="link-mail">
                        <a href="#" class="link-total" @click.prevent="formMailInit = true" :class="{'hide' : formMailInit}">{{ calculatorPage.by_btn_calc }}</a>
                        <formMailCalculator v-if="formMailInit" :options="[{price : price, initPrice: initPrice, pricePercent: pricePercent, curRate: curRate, creditYear: creditYear, payPerMonth: payPerMonth, totalFlatPrice: totalFlatPrice, ovetBankAmount: ovetBankAmount}]"></formMailCalculator>
                    </div>
                    <a href="#" class="link-total link-consult" @click.prevent="getConsultation()">{{ calculatorPage.by_btn_var }}</a>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/antd.css'
    import formMailCalculator from '@/components/forms/form-mail-calculator.vue';
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'hypothec-calculator',
        components: {
            VueSlider,
            svgIcon,
            formMailCalculator,
        },
        data () {
            return {
                formMailInit: false,
                // vars for slider
                minPrice: 1000000,
                maxPrice: 150000000,
                minInitPrice: 500000,
                maxInitPrice: 150000000,
                interval: 500000,
                maxCreditYear: 30,
                maxCurRate: 90,
                // vars for calculator
                price: 11200000, //Стоимость квартиры
                initPrice: 7500000, // Первоначальный взнос
                pricePercent: 1, // Процент от стоимости квартиры в соотношение к первоначальному взносу
                curRate: 7, // Ставка кредита, % годовых:
                creditYear: 25, // Срок кредитования, годы
                // vars for total amount
                payPerMonth: null,
                totalFlatPrice: null,
                ovetBankAmount: null,
                // error var
                errorMsg: false,
            }
        },
        computed: mapGetters({
            calculatorPage: 'loadHypothecCalculatorPage',
        }),
        methods: {
            keymonitor(event) {
                // console.log(event, 'asdasdasd')
                if (this.price > this.maxPrice) {
                    this.price = this.maxPrice
                } 
                // else if (this.price < 1) {
                //     this.price = this.minPrice
                // }
                if (this.initPrice > this.maxInitPrice) {
                    this.initPrice = this.maxInitPrice
                    this.pricePercent = 100
                } 
                // else if (this.initPrice < 1) {
                //     this.initPrice = this.minInitPrice;
                // }
                if (this.curRate > this.maxCurRate) {
                    this.curRate = this.maxCurRate
                } 
                // else if (this.curRate < 1) {
                //     this.curRate = 1;
                // }
                if (this.creditYear > this.maxCreditYear) {
                    this.creditYear = this.maxCreditYear
                } 
                // else if (this.creditYear < 1) {
                //     this.creditYear = 1;
                // }
                this.countPriceInitPercent();
                // this.totalAmountPrice();
            },
            buildDataForCalculator() {
                this.initPrice = Math.floor((this.price * 20) / 100);
            },
            countPriceInitPercent() {
                var precent = Math.floor((this.initPrice/this.price) * 100);
                // console.log(precent)
                if (precent > 0) {
                    if (precent > 100) {
                        this.pricePercent = 100;
                    } else {
                        this.pricePercent = precent;
                    }
                } else {
                    this.pricePercent = 0;
                }
            },
            totalAmountPrice() {
                if (this.price > 0 && this.initPrice > 0 && this.curRate > 0 && this.creditYear > 0) {
                    this.errorMsg = false;
                    // Сумма кредитования 
                    var bankAmount = Number(this.price - this.initPrice);
                    // Ставка в месяц
                    var payMonth = Number((this.curRate / 12) / 100); 
                    // Коэффициент аннуитета
                    var koef = (payMonth * (Math.pow(1 + payMonth,  this.creditYear * 12))) / (Math.pow(1 + payMonth, this.creditYear * 12) - 1); 
                    // console.log(koef)
                    // Ежемесячный платеж
                    var resultPayMonth = (bankAmount * koef).toFixed();
                    // console.log(resultPayMonth)
                    // Общая сумма займа с процентами
                    var totalBankAmount = resultPayMonth * (this.creditYear * 12);
                    // Сумма переплаты от суммы займа с процентами
                    var ovetBankAmount = totalBankAmount - bankAmount;
                    //Общая стоимость жилья с ипотекой
                    // console.log(totalBankAmount, this.initPrice);
                    var totalFlatPrice = Number(totalBankAmount) + Number(this.initPrice);

                    // var overPayment = Math.floor(bankAmount / (this.creditYear * this.curRate));
                    if (this.pricePercent < 100) {
                        this.payPerMonth = this.formatNumber(resultPayMonth);
                        this.totalFlatPrice = this.formatNumber(totalFlatPrice);
                        this.ovetBankAmount = this.formatNumber(ovetBankAmount);
                    } else {
                        this.payPerMonth = 0;
                        this.totalFlatPrice = this.formatNumber(this.price);
                        this.ovetBankAmount = 0;
                    }
                } else {
                    this.errorMsg = true;
                    // console.log('error')
                }
                // console.log(this.curRate)
            },
            getConsultation() {
                // var data = {
                //     'city': this.currentCityArr[0].region,
                //     'page': this.options[0].data_page,
                //     'page_key': this.options[0].data_page_key,
                // }
                // this.$store.commit('getFormConsultData', data);
                this.$store.commit('Open_form_Consult', true);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                // console.log(data);
            },
            formatNumber(num) {
                return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            }
        },
        beforeCreate() {
            // document.body.dataset.page = 'hypothec-calculator';
        },
        created () {
            this.buildDataForCalculator();
            this.countPriceInitPercent();
            this.totalAmountPrice();
            // document.title = this.title;
        },
        mounted() {
        }
    }
</script>


<style lang="scss">
    @import '@/styles/components/hypothec-calculator/hypothec-calculator.scss';
    @import '@/styles/respond/hypothec-calculator/hypothec-calculator-respond.scss';
</style>